<template>
  <div>
    <object :data="invoiceData" type="application/pdf" :width="840" :height="1200">
      <embed :src="invoiceData" type="application/pdf" :width="840" :height="1200" frameBorder="0" scrolling="auto" />
    </object>
  </div>
</template>

<script>
import { TR } from '../../main';
export default {
  props: {},
  data() {
    return {
      data: [],
      title: "",
      buttonOKText: TR.OK,
      buttonCancelText: TR.Cancel,
      searchText: "",
      selected: null,
    };
  },
  computed: {},
  methods: {},
  created() {
    this.invoiceData = this.dialog.data;
  },
  mounted() {},
};
</script>
